document.addEventListener('DOMContentLoaded', () => {
  console.log('Rhege custom.js loaded');
});

document.addEventListener('change', async (event) => {
  const select = event.target.closest('.cart-item__size-select');
  if (!select) return;

  const oldKey = select.dataset.currentKey;
  const newVariantId = Number(select.value);
  const quantity = parseInt(select.dataset.currentQuantity, 10) || 1;

  if (!oldKey || !newVariantId) return;

  const oldWrapper = select.closest('[data-merge-list-item]');
  if (!oldWrapper) return;

  const parent = oldWrapper.parentNode;
  const nextSibling = oldWrapper.nextSibling;

  select.disabled = true;
  oldWrapper.classList.add('merge-item-refreshing');

  try {
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [oldKey]: 0,
          [newVariantId]: quantity
        }
      })
    });

    if (!updateResponse.ok) {
      throw new Error('Cart size update failed');
    }

    const cartResponse = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    const cart = await cartResponse.json();

    const updatedLine = cart.items.find((item) => {
      return item.variant_id === newVariantId;
    });

    if (!updatedLine) {
      window.location.reload();
      return;
    }

    const drawerResponse = await fetch('/?sections=cart-drawer', {
      headers: {
        Accept: 'application/json'
      }
    });

    const sections = await drawerResponse.json();
    const drawerHtml = sections['cart-drawer'];

    if (!drawerHtml) {
      window.location.reload();
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(drawerHtml, 'text/html');

    const newWrapper = Array.from(
      doc.querySelectorAll('[data-merge-list-item]')
    ).find((item) => {
      return (
        item.dataset.mergeListItem &&
        item.dataset.mergeListItem.includes(
          `item-key:${updatedLine.key}|`
        )
      );
    });

    if (!newWrapper) {
      window.location.reload();
      return;
    }

    if (parent) {
      if (nextSibling && nextSibling.parentNode === parent) {
        parent.insertBefore(newWrapper, nextSibling);
      } else {
        parent.appendChild(newWrapper);
      }

      oldWrapper.remove();
    }

    const currentFooter = document.querySelector(
      '.cart-drawer__footer [data-merge="footer"]'
    );

    const newFooter = doc.querySelector(
      '.cart-drawer__footer [data-merge="footer"]'
    );

    if (currentFooter && newFooter) {
      currentFooter.innerHTML = newFooter.innerHTML;
    }

    const currentCheckoutButtons = document.querySelector(
      '[data-merge-attributes="checkout-buttons"]'
    );

    const newCheckoutButtons = doc.querySelector(
      '[data-merge-attributes="checkout-buttons"]'
    );

    if (currentCheckoutButtons && newCheckoutButtons) {
      currentCheckoutButtons.className = newCheckoutButtons.className;
    }

    document.dispatchEvent(
      new CustomEvent('on:cart:change', {
        bubbles: true,
        cancelable: false
      })
    );
  } catch (error) {
    console.error(error);
    window.location.reload();
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest(
    '[data-cart-upsell-variant-select]'
  );

  if (!select) return;

  const card = select.closest('[data-cart-upsell-card]');

  const price = card
    ? card.querySelector('[data-cart-upsell-price]')
    : null;

  const selectedOption = select.options
    ? select.options[select.selectedIndex]
    : null;

  if (
    !price ||
    !selectedOption ||
    !selectedOption.dataset.price
  ) {
    return;
  }

  const currentPrice = selectedOption.dataset.price;
  const compareAtPrice =
    selectedOption.dataset.compareAtPrice;
  const isOnSale =
    selectedOption.dataset.onSale === 'true';

  if (isOnSale && compareAtPrice) {
    price.innerHTML = `
      <span class="cart-upsell-card__compare-price">
        ${compareAtPrice}
      </span>
      <span class="cart-upsell-card__sale-price">
        ${currentPrice}
      </span>
    `;
  } else {
    price.innerHTML = `
      <span class="cart-upsell-card__regular-price">
        ${currentPrice}
      </span>
    `;
  }
});

document.addEventListener('click', async (event) => {
  const addButton = event.target.closest(
    '[data-cart-upsell-add]'
  );

  if (!addButton) return;

  const card = addButton.closest(
    '[data-cart-upsell-card]'
  );

  if (!card) return;

  const variantInput = card.querySelector(
    '[data-cart-upsell-variant-select]'
  );

  const variantId = Number(
    variantInput ? variantInput.value : 0
  );

  if (!variantId) return;

  const originalText = addButton.textContent;

  addButton.disabled = true;
  addButton.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error('Upsell add failed');
    }

    addButton.textContent = 'Added ✓';

    document.dispatchEvent(
      new CustomEvent('on:cart:change', {
        bubbles: true,
        cancelable: false
      })
    );

    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true,
        cancelable: false
      })
    );

    setTimeout(() => {
      addButton.disabled = false;
      addButton.textContent =
        originalText.trim() || 'Add';
    }, 1600);
  } catch (error) {
    console.error(error);

    addButton.disabled = false;
    addButton.textContent = 'Try again';
  }
});